// Piezas comunes de las pantallas de tabla del panel (Usuarios, Recintos…).
// Mismo lenguaje que el Inicio del panel: encabezado con palabra en amarillo,
// tarjetas de resumen que filtran, chips de estado iguales en todas partes.
import React from 'react'

export const claseBtnPrimario =
    'inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-primary !text-white text-sm font-bold shadow-sm hover:brightness-110 transition-all disabled:opacity-60'
export const claseBtnSecundario =
    'inline-flex items-center gap-2 px-5 py-2.5 rounded-full border border-gray-200 bg-white text-gray-700 text-sm font-semibold hover:border-primary hover:!text-primary transition-colors disabled:opacity-50 disabled:pointer-events-none'

export function EncabezadoAdmin({ titulo, destacado, subtitulo, children }) {
    return (
        <header className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-6">
            <div>
                <h1 className="text-3xl font-extrabold text-gray-900 leading-tight m-0">
                    {titulo}{destacado && <> <span className="hl-amarillo">{destacado}</span></>}
                </h1>
                {subtitulo && <p className="text-sm text-gray-500 mt-1 mb-0">{subtitulo}</p>}
            </div>
            {children && <div className="flex flex-wrap items-center gap-2">{children}</div>}
        </header>
    )
}

/** Estado activo/inactivo con el mismo aspecto en todas las tablas. */
export function ChipEstado({ activo, labelActivo = 'Activo', labelInactivo = 'Inactivo' }) {
    return (
        <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-bold whitespace-nowrap
            ${activo ? 'bg-blue-50 text-primary' : 'bg-gray-100 text-gray-500'}`}>
            <span className={`w-1.5 h-1.5 rounded-full ${activo ? 'bg-primary' : 'bg-gray-400'}`} aria-hidden />
            {activo ? labelActivo : labelInactivo}
        </span>
    )
}

/** Chip neutro para categorías (tipo de recinto, rol…): el color queda para el estado. */
export function ChipNeutro({ children }) {
    return (
        <span className="inline-block px-2.5 py-1 rounded-full bg-gray-100 text-gray-700 text-xs font-semibold whitespace-nowrap">
            {children}
        </span>
    )
}

/**
 * Tarjeta de resumen. Con `onClick` funciona como filtro: `activa` la marca en
 * amarillo, igual que los accesos del cliente.
 */
export function TarjetaResumen({ icon, label, value, activa, onClick }) {
    const cuerpo = (
        <>
            <span className={`w-11 h-11 flex-shrink-0 rounded-xl flex items-center justify-center transition-colors
                ${activa ? 'bg-secondary text-[#00266b]' : 'bg-blue-50 text-primary group-hover:bg-secondary group-hover:text-[#00266b]'}`}>
                {icon}
            </span>
            <span className="text-left">
                <span className="block text-2xl font-extrabold text-gray-900 leading-none tabular-nums">{value}</span>
                <span className="block text-xs font-semibold text-gray-500 mt-1">{label}</span>
            </span>
        </>
    )
    const cls = `group flex items-center gap-3 p-4 rounded-2xl border transition-colors
        ${activa ? 'bg-[#fffbea] border-secondary' : 'bg-white border-gray-100'}`
    return onClick
        ? <button type="button" onClick={onClick} aria-pressed={!!activa} className={`${cls} hover:border-secondary w-full`}>{cuerpo}</button>
        : <div className={cls}>{cuerpo}</div>
}

/** Grupo de chips para un filtro de pocas opciones (estado). */
export function FiltroChips({ opciones, valor, onChange, label }) {
    return (
        <div className="inline-flex p-1 rounded-full bg-gray-100" role="group" aria-label={label}>
            {opciones.map(o => (
                <button key={o.value} type="button" onClick={() => onChange(o.value)} aria-pressed={valor === o.value}
                    className={`px-3.5 py-1.5 rounded-full text-sm font-semibold transition-colors
                        ${valor === o.value ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-800'}`}>
                    {o.label}
                </button>
            ))}
        </div>
    )
}

export function Iniciales({ nombre, className = '' }) {
    const ini = (nombre || '').split(' ').filter(Boolean).slice(0, 2).map(p => p[0]).join('').toUpperCase() || '?'
    return (
        <span className={`w-9 h-9 flex-shrink-0 rounded-full bg-blue-50 text-primary text-xs font-extrabold flex items-center justify-center ${className}`}>
            {ini}
        </span>
    )
}
